import React from 'react';
import PropTypes from 'prop-types';

import './WoWBattlegroundRankPicker.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class WoWBattlegroundPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 0;
  static maxValue = 2400;

  static getDefaultValue = () => [0, 1800];

  static marks = {
    0: '0',
    1500: '1500',
    1600: '1600',
    1700: '1700',
    1800: '1800',
    1900: '1900',
    2000: '2000',
    2100: '2100',
    2200: '2200',
    2300: '2300',
    2400: '2400'
  };

  static multipliers = [{from: 0, to: 1500, by: 1/10}];

  render() {
    const {intl, collapsed, value, onChange} = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.rating.current'})}
              min={WoWBattlegroundPicker.minValue}
              max={WoWBattlegroundPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([
                newValue,
                value[1]
              ])}
            />
          </div>

          <div className="range-inputs__divider"/>

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={WoWBattlegroundPicker.minValue}
              max={WoWBattlegroundPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([
                value[0],
                newValue
              ])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-wow-battleground"
              step={50}
              min={WoWBattlegroundPicker.minValue}
              max={WoWBattlegroundPicker.maxValue}
              multipliers={WoWBattlegroundPicker.multipliers}
              marks={WoWBattlegroundPicker.marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/wowBattleground/WoWBattlegroundPicker.js